import {
  PatientControllerApi,
  PatientRoomPropertyControllerApi,
  type AuditLogEntryResponse,
  type PatientDrawerResponse
} from '../api/generated';
import { createApiConfiguration } from '../api/apiConfig';

export async function fetchPatientDetails(
  locationId: string,
  patientId: string
): Promise<PatientDrawerResponse> {
  const api = new PatientControllerApi(createApiConfiguration());
  const response = await api.getPatientDetails({ locationId, patientId });
  return response.data;
}

export async function fetchAuditLog(
  locationId: string,
  patientId: string
): Promise<AuditLogEntryResponse[]> {
  const api = new PatientControllerApi(createApiConfiguration());
  const response = await api.getAuditLog({ locationId, patientId });
  return response.data;
}

export async function fetchRoomProperties(): Promise<Array<{ id: string; name: string }>> {
  const api = new PatientRoomPropertyControllerApi(createApiConfiguration());
  const response = await api.listPatientRoomProperties();
  return response.data.map((rp) => ({ id: rp.id, name: rp.name }));
}
